export const ATTRIBUTE_RULES_TOOLTIP =
  'Customise the product name, image, description and POS ID for each downstream channel.';

export const NO_DESTINATIONS_MESSAGE =
  'There are no destinations defined for this rule. Please ensure there are destinations defined in order for this rule to be published.';
